<template>
    <div>
        <el-dialog v-if="dialogFormVisible" v-el-drag-dialog title="分享记录" :visible.sync="dialogFormVisible" width="1000px" :close-on-click-modal="false">
            <!-- <el-tabs v-model="activeName" @tab-click="handleClick"> -->
            <!-- <el-tab-pane label="可查阅" name="0">
          <el-row type="flex" class="rowbg">
            <el-col :span="20">{{ vo.name }}</el-col>
            <div style="float:right"><el-button plain @click="shareClick(0)">撤销分享</el-button></div>
          </el-row>
          <el-table
            :data="shareList"
            border
            style="width: 100%;margin-top:10px"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              show-overflow-tooltip
              type="selection"
              width="45"
              align="center"
            />
            <el-table-column
              show-overflow-tooltip
              label="序号"
              type="index"
              align="center"
              width="45"
            />
            <el-table-column
              show-overflow-tooltip
              prop="personName"
              label="姓名"
              width="80"
              align="center"
            />
            <el-table-column
              show-overflow-tooltip
              prop="personName"
              label="所属部门"
            />
            <el-table-column
              show-overflow-tooltip
              prop="shareName"
              label="分享人"
              align="center"
              width="80"
            />
            <el-table-column
              show-overflow-tooltip
              :formatter="columnFormatter"
              prop="shareDate"
              label="分享时间"
              align="center"
              width="150"
            />
            <el-table-column
              show-overflow-tooltip
              prop="period"
              label="有效期"
              width="150"
              align="center"
            />
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="已过期" name="1">
          <el-row type="flex" class="rowbg">
            <el-col :span="20">{{ vo.name }}</el-col>
            <div style="float:right"><el-button plain @click="shareClick(1)">再次分享</el-button></div>
          </el-row>
          <el-table
            :data="shareList"
            border
            style="width: 100%;margin-top:10px"
            @selection-change="handleSelectionChange1"
          >
            <el-table-column
              show-overflow-tooltip
              type="selection"
              width="45"
              align="center"
            />
            <el-table-column
              show-overflow-tooltip
              label="序号"
              type="index"
              align="center"
              width="45"
            />
            <el-table-column
              show-overflow-tooltip
              prop="personName"
              label="姓名"
              width="80"
              align="center"
            />
            <el-table-column
              show-overflow-tooltip
              prop="personName"
              label="所属部门"
            />
            <el-table-column
              show-overflow-tooltip
              prop="shareName"
              label="分享人"
              align="center"
              width="80"
            />
            <el-table-column
              show-overflow-tooltip
              prop="shareDate"
              label="分享时间"
              align="center"
              width="150"
            />
            <el-table-column
              show-overflow-tooltip
              prop="period"
              label="有效期"
              width="150"
              align="center"
            />
          </el-table>
        </el-tab-pane> -->
            <!-- <el-tab-pane label="分享记录" name="2"> -->
            <!-- <el-row type="flex" class="rowbg">
        <el-col :span="24">{{ vo.name }}</el-col>
      </el-row> -->
            <el-table :data="shareList" :show-header="true" border style="width: 100%; margin-top: 10px">
                <!-- <el-table-column
          show-overflow-tooltip
          type="selection"
          width="45"
          align="center"
        /> -->
                <el-table-column show-overflow-tooltip label="序号" type="index" align="center" width="45" />
                <el-table-column show-overflow-tooltip prop="shareScope" label="分享范围" align="center" />
                <el-table-column show-overflow-tooltip prop="period" label="有效期" width="150" align="center" />
                <el-table-column show-overflow-tooltip :formatter="columnFormatter" prop="shareDate" label="分享时间" align="center" width="150" />
            </el-table>
            <!-- </el-tab-pane> -->
            <!-- </el-tabs> -->
            <span slot="footer" class="dialog-footer">
                <el-button :icon="'el-icon-close'" @click="dialogFormVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
const moment = require('moment')
export default {
    // import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        return {
            dialogFormVisible: false,
            loginUser: this.$store.getters.loginUser,
            activeName: 0,
            vo: {},
            shareList: [],
            operationList: [], // 可查阅选择的list
            operationList1: [] // 已过期选择的list
        }
    },
    computed: {},
    // 监控data中的数据变化
    watch: {
        dialogFormVisible(val) {
            if (!val) {
                this.activeName = 0
                this.operationList = []
                this.operationList1 = []
            }
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        // 分享记录
        this.$bus.$on('ShareRecord', (res) => {
            console.log(res, 'res')
            this.vo = res
            this.getlistdata()
        })
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {
        // 分享记录
        this.$bus.$off('ShareRecord')
    }, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    activated() {},
    // 方法集合
    methods: {
        // 分享按钮操作
        shareClick(val) {
            if (!val) {
                // 可查阅撤销分享
                if (this.operationList.length < 1) {
                    this.$alert('请选择要撤销分享的记录!', '提示', {
                        type: 'warning'
                    })
                    return
                }
            } else {
                // 已过期再次分享
                if (this.operationList1.length < 1) {
                    this.$alert('请选择要再次分享的记录!', '提示', {
                        type: 'warning'
                    })
                    return
                }
                this.operationList1
            }
        },
        // 切换tab
        handleClick() {
            this.getlistdata()
        },
        // 获取列表数据
        async getlistdata() {
            const { staffList, personId, orgCode } = { ...this.loginUser }
            if (Number(this.activeName) === 0) {
                const params = {
                    pageNum: 1,
                    pageSize: 100000,
                    urlsearch: `fileId:${this.vo.id};status!:1` // status:1分享文件;status:2全部分享记录;status:3有效期内的分享记录
                }
                const res = await this.$app.listdata('disk/vwsharefile/listdata', params)
                if (res.code === 'success') {
                    this.shareList = res.body.pageInfo.list
                    this.dialogFormVisible = true
                } else {
                    this.$message.error(res.message)
                }
            } else if (Number(this.activeName) === 1) {
                const params = {
                    pageNum: 1,
                    pageSize: 100000,
                    urlsearch: 'fileId:' + this.vo.id + ';orgCode:' + orgCode
                }
                const res = await this.$app.listdata('disk/vwreaderfile/listdata', params)
                if (res.code === 'success') {
                    this.shareList = res.body.pageInfo.list
                } else {
                    this.$message.error(res.message)
                }
            } else if (Number(this.activeName) === 2) {
                const params = {
                    pageNum: 1,
                    pageSize: 100000
                    // urlsearch: 'shareId:' + this.vo.id
                }
                const res = await this.$app.listdata('disk/vwreaderfile/listdata', params)
                if (res.code === 'success') {
                    this.shareList = res.body.pageInfo.list
                } else {
                    this.$message.error(res.message)
                }
            }
        },
        handleSelectionChange(list) {
            this.operationList = list
        },
        handleSelectionChange1(list) {
            this.operationList1 = list
        },
        // 格式化时间
        columnFormatter(row, column, cellValue, index) {
            if (cellValue) {
                return moment(cellValue).format('YYYY-MM-DD HH:mm')
            } else {
                return ''
            }
        }
    } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
.rowbg {
    height: 35px;
    justify-content: space-between;
    align-items: center;
}
</style>
